import phoneImg from '../../assets/images/phone.png';

const steps = [
  {
    id: '01',
    title: 'Accept delivery requests',
    description: 'Get notified when an order is ready for pickup. Tap to accept and get moving.',
  },
  {
    id: '02',
    title: 'Pick up the package',
    description: 'Use the in-app map to locate the sender and securely collect the parcel.',
  },
  {
    id: '03',
    title: 'Deliver to the customer',
    description: 'Navigate with built-in directions and complete the delivery with proof of drop-off.',
  },
  {
    id: '04',
    title: 'Earn and track performance',
    description: 'Get paid for every completed trip. Monitor earnings and delivery ratings in your dashboard.',
  },
];

function HowItWorks() {
  return (
    <section id="how" className="container mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Image */}
        <div className="flex justify-center lg:justify-start order-2 lg:order-1">
          <img src={phoneImg} alt="Driver App" className="max-w-xs sm:max-w-sm md:max-w-md" />
        </div>

        {/* Steps */}
        <div className="space-y-8 order-1 lg:order-2">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold mb-2">
              How the Speedyssey rider app works
            </h2>
            <p className="text-gray-700 md:text-lg">
              Seamless, simple, and built to help you earn on your schedule.
            </p>
          </div>

          <ol className="space-y-6">
            {steps.map((step) => (
              <li
                key={step.id}
                className={`
                  flex flex-col sm:flex-row items-start gap-2 sm:gap-4
                `}
              >
                {/* On mobile: number above title, on desktop: number left of title */}
                <div
                  className={`
                    flex flex-col items-start sm:items-start w-full sm:w-auto
                  `}
                >
                  <span
                    className={`
                      inline-flex
                      items-center
                      justify-center
                      font-semibold
                      text-white
                      shrink-0
                      mb-2
                      sm:mb-0
                      sm:mr-0
                      text-base
                      md:text-lg
                      select-none
                      rounded-xl
                    `}
                    style={{
                      background: 'linear-gradient(135deg, #F55109 0%, #FF8C42 100%)',
                      borderRadius: '999px / 60px', // oval shape
                      width: '56px',
                      height: '36px',
                      minWidth: '56px',
                      minHeight: '36px',
                      fontSize: '1.1rem',
                      letterSpacing: '0.05em',
                    }}
                  >
                    {step.id}
                  </span>
                  {/* Only show title here on mobile */}
                  <h3
                    className={`
                      font-semibold text-lg md:text-xl
                      mb-1
                      text-center
                      sm:hidden
                    `}
                  >
                    {step.title}
                  </h3>
                </div>
                {/* On mobile: description below, on desktop: title+desc right of number */}
                <div className="flex-1">
                  <h3
                    className={`
                      font-semibold text-lg md:text-xl mb-1
                      hidden sm:block
                    `}
                  >
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
